const SGF_HISTORY_STORAGE_VERSION_KEY =
    'goproblems:storage:sgf-history:version';
const LEGACY_SGF_HISTORY_STORAGE_VERSION_KEY = 'sgfHistoryStorageVersion';

const SGF_HISTORY_STORAGE_VERSION = '1';

const RETAINED_SGF_HISTORY_SCOPES: readonly RegExp[] = [
    /^ProblemEdit\d+History$/,
    /^newSuggestProblem\d+History$/,
    /^editSuggestProblem\d+History$/,
    /^resolveSuggestProblem\d+History$/,
    /^viewSuggestProblem\d+History$/,
    /^ProblemDraft\d+History$/,
    /^ProblemDraftResolve\d+History$/,
    /^researchProblem\d+History$/,
    /^InvasionEdit\d+History(?:_metadata)?$/,
];

const SINGLETON_SGF_HISTORY_SCOPES: readonly RegExp[] = [
    /^sgfHistory$/,
    /^ProblemCreateHistory$/,
    /^suggestHistory$/,
    /^analysisHistory$/,
    /^InvasionCreateHistory(?:_metadata)?$/,
];

const LEGACY_SGF_HISTORY_SCOPES: readonly RegExp[] = [
    /^sgfCreateProblem$/,
    /^sgfEditProblem\d+$/,
    /^sgfResolveProblem\d+$/,
];

const ALL_SGF_HISTORY_SCOPES: readonly RegExp[] = [
    ...RETAINED_SGF_HISTORY_SCOPES,
    ...SINGLETON_SGF_HISTORY_SCOPES,
    ...LEGACY_SGF_HISTORY_SCOPES,
];

const getLocalStorageKeys = (): string[] => {
    const keys: string[] = [];

    for (let index = 0; index < localStorage.length; index += 1) {
        const key = localStorage.key(index);
        if (key !== null) {
            keys.push(key);
        }
    }

    return keys;
};

const removeMatchingHistories = (
    patterns: readonly RegExp[],
    preservedKeys: ReadonlySet<string> = new Set()
): void => {
    for (const key of getLocalStorageKeys()) {
        if (
            !preservedKeys.has(key) &&
            patterns.some(pattern => pattern.test(key))
        ) {
            localStorage.removeItem(key);
        }
    }
};

export const migrateSgfHistoryStorage = (): void => {
    try {
        if (
            localStorage.getItem(SGF_HISTORY_STORAGE_VERSION_KEY) ===
            SGF_HISTORY_STORAGE_VERSION
        ) {
            return;
        }

        removeMatchingHistories(ALL_SGF_HISTORY_SCOPES);
        localStorage.removeItem(LEGACY_SGF_HISTORY_STORAGE_VERSION_KEY);
        localStorage.setItem(
            SGF_HISTORY_STORAGE_VERSION_KEY,
            SGF_HISTORY_STORAGE_VERSION
        );
    } catch (error) {
        console.warn('Unable to migrate stored SGF histories:', error);
    }
};

export const retainOnlyCurrentSgfHistory = (
    ...currentStorageKeys: string[]
): void => {
    const preservedKeys = new Set(currentStorageKeys);
    const matchingScopes = RETAINED_SGF_HISTORY_SCOPES.filter(pattern =>
        currentStorageKeys.some(key => pattern.test(key))
    );

    if (matchingScopes.length === 0) {
        return;
    }

    try {
        removeMatchingHistories(matchingScopes, preservedKeys);
    } catch (error) {
        console.warn('Unable to clean up stored SGF histories:', error);
    }
};
